// extracted by mini-css-extract-plugin
export default {"News":"News_News__V19r5"};